import { render, staticRenderFns } from "./BundleDiscountLabel.vue?vue&type=template&id=be78b016&"
import script from "./BundleDiscountLabel.vue?vue&type=script&lang=ts&"
export * from "./BundleDiscountLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports